import React from 'react';
import { Alert } from '@planne-software/uni/Alert';
import { Button } from '@planne-software/uni/Button';
import { IconAlertTriangle } from '@tabler/icons-react';

import { Spinner } from '@src/components/reusable';
import {
  useAppDispatch,
  useAppSelector,
  useTranslate,
  useWidgetParam,
  useWidgetsTheme as theme,
} from '@src/core/hooks';
import { changeLocation } from '@src/core/store';
import { currentOrderSelector, resetOrder } from '@src/features/orders/store/order';
import { currentSaleSelector, resetSale } from '@src/stores/sale';

import { awaitingConfirmationTarget } from '../core/awaitingConfirmationTarget';
import { Message, SpinnerWrapper, Wrapper } from '../styles';
import { useConfirmationPoll } from './useConfirmationPoll';

export const ConfirmationWait = () => {
  const { i18n, i18nElement } = useTranslate();
  const dispatch = useAppDispatch();
  const actionColor = theme('actionColor');
  const continueShoppingPage = useWidgetParam('continue-shopping-page');
  const currentOrder = useAppSelector(currentOrderSelector);
  const currentSale = useAppSelector(currentSaleSelector);
  const pollTarget = awaitingConfirmationTarget(currentOrder, currentSale);
  const { unavailable } = useConfirmationPoll(pollTarget);

  const chooseAnotherDateOrTime = () => {
    dispatch(pollTarget?.type === 'sale' ? resetSale() : resetOrder());
    dispatch(changeLocation(continueShoppingPage || '/'));
  };

  if (unavailable) {
    return (
      <Wrapper>
        <Alert
          data-testid='order-confirmation-unavailable-alert'
          severity='warning'
          startIcon={<IconAlertTriangle size={20} aria-hidden />}
          title={i18n('checkout_awaiting_confirmation_unavailable_title')}
          subTitle={i18n('checkout_awaiting_confirmation_unavailable_description')}
          action={
            <Button size='xs' variant='slim' color='primary' onClick={chooseAnotherDateOrTime}>
              {i18n('checkout_awaiting_confirmation_unavailable_action')}
            </Button>
          }
        />
      </Wrapper>
    );
  }

  return (
    <Wrapper>
      <SpinnerWrapper>
        <Spinner visible spinnerColor={actionColor} />
      </SpinnerWrapper>
      <Message>{i18nElement('checkout_awaiting_confirmation_message')}</Message>
    </Wrapper>
  );
};
